module.exports = __webpack_public_path__ + "img/vertical_7_4_3009.d259b0e1.png";